import request from '@/utils/request'
import { Result } from '@/utils/typings'
/*
Api example
泛型 T 不是必须的
若要指定返回值类型，可传递泛型给Result对象
*/
export function getListBoxApi<T = any, D = any>(params: T): Promise<Result<D>> {
  return request({
    url: `/buyer/blind-box/ad/${params.id}`,
    method: 'get',
    params,
  })
}

export function getListGoodsApi<T = any, D = any>(): Promise<Result<D>> {
  return request({
    url: `/buyer/goods/ad-list`,
    method: 'get',
  })
}

/**
 * 填写收货地址
 * @param params
 */

export function saveAddress<T = any, D = any>(params: T): Promise<Result<any>> {

  return request({
    url: 'buyer/pay/escrow/save-address',
    method: 'get',
    params,
  })

}
export function getVersionInfo<T = any, D = any>(params: T): Promise<Result<D>> {
  return request({
    url: `/buyer/version/getVersionInfo`,
    method: 'post',
     params,
  })
}
